





































import { Component, Mixins, Prop, Emit } from 'vue-property-decorator'
import FormStoreComponent from '@/tcw/components/FormStoreComponent'
import { ApiGeneralSinglePayload } from '@/tcw/api/types'
import { MemoInputFormStore, memoInputStore } from '@/store/form/MemoInputFormStore'
import { IFormStore } from '@/store/types'
import { KeyInfo } from '@/components/common/form/types'
import TcwFormItemCommon from '@/components/common/form/mixins/TcwFormItemCommon'
import TcwFormItem from '@/components/common/form/TcwFormItem.vue'
import VueMarkdown from 'vue-markdown'

export interface AutoSize {
  minRows: number
  maxRows: number
}

@Component({
  components: { TcwFormItem, VueMarkdown }
})

export default class MemoInputForm extends Mixins(FormStoreComponent, TcwFormItemCommon) {
  @Prop({ default: 10 })
  private rows!: number
  @Prop({ default: 10 })
  private minRows!: number
  @Prop({ default: 10 })
  private maxRows!: number
  @Prop({ default: () => [] })
  @Prop({ type: Boolean, default: false })

  private preview = 'input'

  private memoId = 1

  get formName(): string {
    return 'memoMarkdownForm'
  }
  get storeModule(): IFormStore<ApiGeneralSinglePayload> {
    return memoInputStore
  }
  get memoStore(): MemoInputFormStore {
    return this.storeModule as MemoInputFormStore
  }
  get keyInfo(): KeyInfo {
    if (this.memoId && !this.isNewRecord) {
      return { id: this.memoId }
    } else {
      return {}
    }
  }
  get form(): ApiGeneralSinglePayload {
    return this.storeModule.editData !== null ? this.storeModule.editData : {}
  }
  get isNewRecord(): boolean {
    return memoInputStore.isNewRecord
  }

  protected async beforeProc(): Promise<void> {
    if (this.isEmptyRecord) {
      this.storeModule.clear()
    }
  }

  protected async validate(): Promise<void> {
    console.log('')
  }

  private get autosize(): AutoSize {
    const minRows = this.minRows ? this.minRows : this.rows
    let maxRows = this.maxRows ? this.maxRows : this.rows
    if (minRows > maxRows) {
      maxRows = minRows
    }
    return { minRows, maxRows }
  }

  private get markdownFormItemStyle(): { [key: string]: string } {
    const style = this.formItemStyle
    style['position'] = 'relative'
    return style
  }

  private get markdownStyle(): { [key: string]: string } {
    return {
      width: '100%',
      height: this.markdownHeight,
      padding: '5px 15px',
      border: '1px solid #DCDFE6',
      'border-radius': '4px',
      'background-color': '#f0f8ff',
      'overflow-y': 'auto'
    }
  }

  private get markdownHeight(): string {
    if (!this.preview) {
      return ''
    }

    const textareaRef = this.$refs.textarea as Vue
    if (!textareaRef) {
      return ''
    }
    return textareaRef.$el.scrollHeight + 'px'
  }

}
